// extracted by mini-css-extract-plugin
module.exports = {"pagination":"pagination_2LL","next":"next_17H","prev":"prev_3Ke"};